import { render, staticRenderFns } from "./Semaforo2c.vue?vue&type=template&id=276c40da"
import script from "./Semaforo2c.vue?vue&type=script&lang=js"
export * from "./Semaforo2c.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports